import { Brand } from '@/domainLogic/index.ts';

export const HEADER_HEIGHT = (brand?: Brand, isMobile?: boolean, isApp?: boolean) => {
  if (isApp) return 0;
  return (brand === Brand.HOLIDAYPIRATES && 78) || (brand === Brand.HOLIDAYGURU && (isMobile ? 73 : 82)) || 64;
};

export const SEARCH_WIDGET_HEIGHT = 78;
export const FILTERS_HEIGHT = 72;

// Only HolidayPirates' external header is wrapped in the viewport-fixed ExternalHeader
// container; HolidayGuru's is injected in-flow (HtmlInjector) and scrolls with the page.
export const hasFixedExternalHeader = (brand?: Brand) => brand === Brand.HOLIDAYPIRATES;
